/**
 * Creates a unique id for a header search session.
 * Falls back when `crypto.randomUUID` is unavailable (e.g. some test environments).
 */
export function createSearchSessionId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `search-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
